/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_Step_OneInputs */

const en_cc_step_one = /** @type {(inputs: Cc_Step_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download and extract the ZIP into a permanent folder.`)
};

const id_cc_step_one = /** @type {(inputs: Cc_Step_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh dan ekstrak ZIP ke folder tetap.`)
};

/**
* | output |
* | --- |
* | "Download and extract the ZIP into a permanent folder." |
*
* @param {Cc_Step_OneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_step_one = /** @type {((inputs?: Cc_Step_OneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_Step_OneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_step_one(inputs)
	return en_cc_step_one(inputs)
});